import { Injectable } from "@angular/core";

import { RestServiceBase } from "@definitiv-packages/angular-dba-library";

import { SafetyPointModel } from "../../types/safety-point-model";


@Injectable({
    providedIn: 'root'
})
export class SafetyPointService extends RestServiceBase<SafetyPointModel> {
    constructor() { super("SafetyPointModel"); }
}